import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class userdeniedService {
  constructor(private msalService: MsalService, private http: HttpClient) { }

  private getUserName(): string {
    const account = this.msalService.instance.getActiveAccount();
    return account?.username || '';
  }

  NonPPMDUserValidate(): Promise<{ userName: string; jobTitle: string } | null> {
    const username = this.getUserName();
    const headers = new HttpHeaders({
      'username': username
    });

    return this.http
      .get<any>(`${environment.apiBaseUrl}/Account/NonPPMDUserValidate`, { headers })
      .toPromise()
      .then(data => {
        if (data && data.value && data.value.length > 0) {
          const user = data.value[0];
          return { userName: user.displayName, jobTitle: user.jobTitle };
        }
        return null;
      })
      .catch(error => {
        console.error('Error calling /Account/NonPPMDUserValidate API:', error);
        return null;
      });
  }
  
  sendEmail(
    userName: string,
    userEmail: string,
    pageName: string
  ): Observable<{ userName: string; userEmail: string; pageName: string } | null> {    
    const body = {
      Username: userName,
      UserEmail: userEmail,
      PageName: pageName
    };
    return this.http
      .post<any>(`${environment.apiBaseUrl}/Mail/SendAccessDeniedMail`, body)
      .pipe(
        map(data => {
          if (data && data.value && data.value.length > 0) {
            const user = data.value[0];
            return {
              userName: user.displayName,
              userEmail: user.mail,
              pageName: user.pageName
            };
          }
          return null;
        }),
        catchError(error => {
          console.error('Error calling /Mail/SendAccessDeniedMail API:', error);
          return of(null);
        })
      );
  }
}
